export default {
  AgreementLabel: 'I accept all the terms of the {link}.',
  AgreementLabelAnchor: 'User Agreement',
  AnotherUser: 'Another user',
  ApplicationAskPermissions: 'Application {app} requests access to your data:',
  AuthorizeButtonText: 'Allow access',
  BackHome: 'Return',
  Cancel: 'Cancel',
  Close: 'Close',
  ConfirmationTitle: 'Confirmation',
  ConsentTitle: 'Authorize application',
  DeclineAuthorizationButtonText: 'Deny access',
  EmailHint: 'A code will be sent here to complete the registration.',
  EmailLabel: 'Email',
  Error404Title: 'Page not found',
  FatalErrorDefaultMessage: 'Error',
  FillCode: 'Enter a code',
  FillLogin: 'Choose login',
  FillNewPassword: 'Enter new password',
  FillSecret: 'Enter the secret code and enter the new password:',
  ForgotTitle: 'Password recovery',
  ForgotMobileTitle: 'Recovery password',
  ForgotQuestion: 'Forgot?',
  Go: 'Go to',
  here: 'here',
  HomePage: 'Home page',
  LoggedOut: 'Session complete',
  LoginAgain: 'Sign in again',
  LoginAnotherUser: 'sign in with a different user:',
  LoginAs: 'Login as',
  LoginButtonText: 'Login',
  LoginLabel: 'Username, phone or email',
  LoginShortLabel: 'Login',
  LoginHint: 'Used to enter the site.',
  LoginTitle: 'Login',
  LogoutConfirmationButtonText: 'Log out',
  LogoutConfirmationHint: 'You are going to destroy session on all of your devices.',
  LogoutConfirmationTitle: 'Log out',
  MinLength: 'Minimum {min} characters',
  NewPassword: 'New password',
  NetworkError: 'Error connecting to server.',
  Next: 'Next',
  NoContactsError: 'Unfortunately, you did not leave any contact information where we could send the recovery code. You can still restore access by contacting the site administration.',
  offlineScopeTitle: 'Offline access',
  offlineScopeDescription: 'Application needs to refresh access tokens when you are not present at the browser.',
  openidScopeTitle: 'Public data only',
  openidScopeDescription: 'This application will be able to identify you and read public information.',
  OrFillUser: 'Or specify the user:',
  PasswordLabel: 'Password',
  PasswordTestLabel: 'Repeat password',
  PasswordsNotEqualError: 'Passwords are not equal',
  PolicyRequiredError: 'You have to accept the privacy policy',
  PrivacyLabel: 'I have read the {link} and agree to the processing of my personal data.',
  PrivacyLabelAnchor: 'Privacy Policy',
  RememberMe: 'Remember me',
  ResendCode: 'To resend the code, click',
  RequiredError: 'Field is required.',
  SavePassword: 'Save password',
  SecretCode: 'Secret code',
  SelectOneUser: 'On the request of {login}, we found several users. Select which one you want to restore access to.',
  SelectPasswordFor: 'Restore password for:',
  SelectUser: 'Select user?',
  SelectWay: 'Select way',
  SelectRecoverWay: 'Select recovery way:',
  SentEmail: 'You have received a letter with a secret code to change your password.',
  SentError: 'In progress an error has occurred.',
  SentSms: 'You have sent a text message with a secret code to change your password.',
  SignedIn: 'You are authorized!',
  SignedUp: 'Are you registered!',
  RegisterLinkText: 'Register',
  RegisterTitle: 'Registration on',
  RegisterPageTitle: 'Registration',
  SmsCode: 'Secret code from',
  TelHint: 'For notifications and password recovery via SMS.',
  TelLabel: 'Phone',
  TimeoutError: 'You recently requested a password recovery code. If you did not receive it, next time you can request it via {countdown}.',
  TimeoutHint: 'If you do not receive the code, the next time you can request it through {countdown}.',
  TosRequiredError: 'You have to accept all terms of the user agreement',
  TooEasyPasswordError: 'Too easy password.',
  UserNotFound: 'User not found.',
  WillRedirect: 'Now you will be redirected to the site.',
  WillRedirectAfterLogout: 'Session destroyed. In a few seconds you will return to the site.',

  // validation errors
  'email must be an email': 'Invalid email',
  'tel must be a phone number': 'This is not a mobile phone number'
}
